export default {
  methods: {
    scrollTop: function () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
